// @flow

import React, { Component, Fragment } from "react";
import { noop, toNumber } from "lodash";
import type { UnaryFn } from "@tvg/types/Functional";
import formatCurrency from "@tvg/formatter/currency";
import betAmountValidation from "@tvg/api/wtx/BetAmountHelper";
import {
  ClearButton,
  CustomAmountContainer,
  UpdateButtonContainer,
  CustomAmountInput,
  CustomAmountLabel,
  MessageWrapper
} from "./styled-components";
import buildColor from "../../_static/ColorPalette";
import { errorOutline } from "../../_static/Icons/icons";
import Icon from "../../_static/Icons";
import Button from "../../_atom/Buttons/button";
import MessageBox from "../MessageBox";

type Props = {
  onUpdateBetAmount: UnaryFn<number, mixed>,
  minimumAmount: number
};

type State = {
  amount: number,
  message: string
};

export default class CustomAmount extends Component<Props, State> {
  static defaultProps = {
    onUpdateBetAmount: noop,
    minimumAmount: 0.1
  };

  constructor(props: Props) {
    super(props);

    this.state = {
      amount: 0,
      message: ""
    };
  }

  onClearAmount = () => {
    this.setState({
      amount: 0,
      message: ""
    });

    this.putFocusOnInput();
  };

  onChangeAmount = (format: *) => {
    if (format.floatValue >= 100000) {
      this.setState({ amount: this.state.amount });
      return;
    }

    if (
      isNaN(format.value[0]) ||
      isNaN(format.value[format.value.length - 1])
    ) {
      // $FlowFixMe
      this.setState({ amount: format.value }); // keep the value as it is in case the user use the "." to enter a decimal value
      this.putFocusOnInput();
    } else {
      this.setState({ amount: parseFloat(format.value) }); // remove zero from the begin of the string value if the amout is 1 or bigger. eg: 01.03 --> 1.03
    }
  };

  onUpdateBetAmount = (value: number) => {
    const validation = betAmountValidation(value, this.props.minimumAmount);
    if (validation && validation.message) {
      this.setState({
        message: validation.message,
        amount: validation.amount
      });
    } else {
      this.props.onUpdateBetAmount(validation.amount);
      this.setState({
        message: "",
        amount: validation.amount
      });
    }
  };

  putFocusOnInput = () => {
    const elem = document.getElementById("customAmountInputId");
    if (elem) {
      // $FlowBug
      elem.focus();
      // $FlowBug
      setTimeout(() => elem.setSelectionRange(100, 100), 0); // this will throw the cursor to the end of the input
    }
  };

  render() {
    return (
      <Fragment>
        {this.state.message && (
          <MessageWrapper>
            <MessageBox type="warning" message={this.state.message} />
          </MessageWrapper>
        )}
        <CustomAmountContainer>
          <CustomAmountInput
            onValueChange={this.onChangeAmount}
            value={this.state.amount}
          />
          <CustomAmountLabel data-qa-label="customAmount-minimumAmountLbl">
            {`${formatCurrency(this.props.minimumAmount)} Minimum`}
          </CustomAmountLabel>
          <ClearButton
            onClick={this.onClearAmount}
            qaLabel="customAmount-clearBtn"
          >
            <Icon
              icon={errorOutline}
              size={16}
              color={buildColor("grey", "900")}
            />
          </ClearButton>
        </CustomAmountContainer>
        <UpdateButtonContainer>
          <Button
            size="big"
            qaLabel="customAmount-updateAmountBtn"
            onClick={() => this.onUpdateBetAmount(toNumber(this.state.amount))}
          >
            Update Bet Amount
          </Button>
        </UpdateButtonContainer>
      </Fragment>
    );
  }
}
